import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextAreaFieldWUT } from '../../../ui/text-area-field';
export const DextTextAreaWUT = props => {
  const fieldType = FIELD_TYPES.DEXT_TEXT_AREA;
  return /*#__PURE__*/React.createElement(TextAreaFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=dext-text-area-wut.js.map